import BaseModel from '../BaseModel';
import Question from './Question';

export default class Test extends BaseModel {
  static entity = 'test';

  static fields() {
    return {
      id: this.attr(null),
      minimalScore: this.attr(null),
      questions: this.hasMany(Question, 'testId'),
      scoreType: this.string(null).nullable(),
      timer: this.attr(null),
      type: this.string(null).nullable(),
      vacancyId: this.attr(null),
      candidateId: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      getTestInfo(id) {
        return this.get(`vacancies/${id}/test`);
      },
      getRedactingTestInfo(id) {
        return this.get(`vacancies/${id}/redacting-test`);
      },
      createRedactingTest(vacancyId, testId) {
        return this.get(`vacancies/${vacancyId}/test/redacting/${testId}`);
      },
      createTest(id, payload) {
        return this.post(`vacancies/${id}/test`, payload);
      },
      updateTest(id, testId, payload) {
        return this.patch(`vacancies/${id}/test/${testId}`, payload);
      },
      publishTest(id, testId) {
        return this.post(`vacancies/${id}/test/${testId}`);
      },
      unpublishTest(id) {
        return this.delete(`vacancies/${id}/test`);
      },
      removeTest(id, testId) {
        return this.delete(`vacancies/${id}/test/${testId}`);
      },
    },
  }
}
